// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".current-plan .plan-details-header {\n  font-size: 14px;\n  line-height: 24px;\n  color: var(--carbon-900);\n}\n.current-plan .plan-details-header-notice {\n  font-size: 18px;\n  line-height: 24px;\n  font-weight: 1000;\n  color: var(--carbon-900);\n}", ""]);
// Exports
module.exports = exports;
